import { render } from "./index.vue?vue&type=template&id=fe283394&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fe283394&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe283394"]])

export default __exports__